import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import { getGetFrontRichiesteIdPagamentiIdRicevutaQueryOptions } from '@framework/api-client/api/inquiries-compile/richieste-controller/richieste-controller.ts';
import { type PagamentoWithDettaglioDTO } from '@framework/api-client/api/inquiries-compile/schemas/pagamentoWithDettaglioDTO.ts';
import { getNetworkErrorMessage } from '@framework/auth/http/errors/getNetworkErrorMessage.ts';
import { useHasDocumentsInlineViewer } from '@framework/common-web/ui/documents/useHasDocumentsInlineViewer.tsx';
import { useAuthDownload } from '@framework/common-web/utils/download/useAuthDownload.ts';
import { Button, type ButtonProps, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { EnumCodStatoPagamento } from '../../burden/payments/EnumCodStatoPagamento.tsx';

interface DownloadPaymentReceiptButtonProps {
  payment: PagamentoWithDettaglioDTO;
  type?: ButtonProps['type'];
  size?: ButtonProps['size'];
}

export function DownloadPaymentReceiptButton(
  props: DownloadPaymentReceiptButtonProps,
) {
  const { payment, type, size } = props;
  const { t } = useTranslation();
  const hasInlineViewer = useHasDocumentsInlineViewer();
  const theme = useTheme();

  const { download, isFetching } = useAuthDownload(
    getGetFrontRichiesteIdPagamentiIdRicevutaQueryOptions,
    [payment.idRichiesta!, payment.id!],
    {
      onError: e => {
        getNetworkErrorMessage(
          e,
          t(
            'download-receipt.errore-in-download',
            'Si è verificato un problema durante il download del file',
          ),
        );
      },
      showInlineViewer: hasInlineViewer,
    },
  );

  if (payment.codStatoPagamento !== EnumCodStatoPagamento.SUCCESSO) return null;

  return (
    <Tooltip title={t('form.scarica-ricevuta', 'Scarica Ricevuta')}>
      <Button
        icon={
          !hasInlineViewer ? (
            <DownloadOutlined
              aria-label={t('form.scarica-ricevuta', 'Scarica Ricevuta')}
            />
          ) : (
            <EyeOutlined aria-label={`${theme.viewPdfLabel} Ricevuta`} />
          )
        }
        onClick={() => download()}
        disabled={!payment.id}
        loading={isFetching}
        size={size}
        type={type}
      />
    </Tooltip>
  );
}
